import React from 'react';

import { FormattedMessage } from 'react-intl';

import { PROVIDER } from '../../../../../filters/constants';
import { renderFormBasedOnType } from '../../../../../services/filtering/filter-form-render-service';
import { OptionFormTypes } from '../../../../../services/filtering/filter-form-render-service/option-form-types';
import messages from './messages';

export default {
  id: PROVIDER,
  displayName: <FormattedMessage {...messages.provider} />,
  type: OptionFormTypes.TYPE_ORDER_COLLECTION_FILTER,
  filterValue: 'ProviderId',
  expectsArgumentAsArray: true,
  allowsMultipleSelection: true,
  render: (criteriaInformations, existingFiltersHelpers) => {
    return renderFormBasedOnType(OptionFormTypes.TYPE_CHECKLIST, criteriaInformations, existingFiltersHelpers);
  },
  shouldHideActionButtons: true,
};
